export default __webpack_public_path__ + "2558d045b76881a78bbfda640bdd1f34.woff";